// extracted by mini-css-extract-plugin
module.exports = {"saveSearchControl":"SaveSearchContainer_saveSearchControl__X9bMx"};